<template>
  <section id="organization" ref="organization">
    <div class="spacer">
      <div class="big title">{{ organization.title }}</div>
      <collapse
        v-for="item in organization.organizers"
        :key="item.title"
        :uid="item.uid"
        :fold="true"
        parent="organization"
      >
        <template v-slot:header>
          <div class="first">{{ item.name }}</div>
        </template>
        <template v-slot:content>
          <div class="grid">
            <div>
              <img v-if="item.image" :src="item.image.url" :alt="item.name" />
            </div>
            <div>
              <div class="mb" v-html="item.bio"></div>
            </div>
          </div>
        </template>
      </collapse>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      organization: []
    };
  },
  created() {
    API.organization(this.$i18n.locale).then(page => {
      this.organization = page.data.result;
    });
  }
};
</script>

<style></style>
